import * as React from 'react';

import {handleRequestAnimationFrame} from '../components/stage-slider/utils/handleRequestAnimationFrame';

export function useLoopingAnimation(
    className: string,
    condition: boolean,
    index: number,
    elementRef: React.MutableRefObject<HTMLDivElement | null>,
    callback: (event: React.SyntheticEvent<Element, Event>) => void,
    timeout: number,
    handleAnimationEnd?: () => void
) {
    React.useEffect(() => {
        const rotationBtn = elementRef.current;
        let timer: NodeJS.Timeout | number | null = null;

        if (rotationBtn) {
            handleRequestAnimationFrame(rotationBtn, className);
        }

        const fn = () => {
            callback({
                stopPropagation: () => {}
            } as React.SyntheticEvent);

            if (handleAnimationEnd) {
                handleAnimationEnd();
            }
        };

        if (!timer && condition) {
            const timeoutDuration = timeout * 1000;
            timer = setTimeout(fn, timeoutDuration);
        }

        return () => {
            if (typeof timer === 'number') {
                clearTimeout(timer);
                timer = null;
            }
        };
    }, [
        callback,
        className,
        condition,
        elementRef,
        handleAnimationEnd,
        index,
        timeout
    ]);
}
